export default __webpack_public_path__ + "static/brian-d86e041e1257a933bf3886b249e030a6.jpg";